export default __webpack_public_path__ + "static/media/yellow-sun.452328a8.svg";